import React from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import { PassingStats } from "../../../../types/LogTypes";
import { useRoster } from "../../../../contexts/RosterContext";
import "./../Styles/Offense.css";
import { jerseyNumberNameDisplay } from "../../../../helpers/helpers";

interface Props {
  passingStats?: PassingStats;
}

export const Passing: React.FC<Props> = ({ passingStats }) => {
  const { rosterPlayers } = useRoster();

  if (!passingStats) {
    return null;
  }

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant="h6">Passing</Typography>
      </Box>
      <TableContainer>
        <Table className="stats-table">
          <TableHead>
            <TableRow>
              <TableCell className="player-name">Player</TableCell>
              <TableCell className="stat-cell">Comp</TableCell>
              <TableCell className="stat-cell">Att</TableCell>
              <TableCell className="stat-cell">Yards</TableCell>
              <TableCell className="stat-cell">TD</TableCell>
              <TableCell className="stat-cell">Int</TableCell>
              <TableCell className="stat-cell">Cmp %</TableCell>
              <TableCell className="stat-cell">Rating</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(passingStats).map(([rosterId, stats]) => {
              const player = rosterPlayers.find(
                (p) => p.id === parseInt(rosterId)
              );
              return (
                <TableRow key={rosterId}>
                  <TableCell className="player-name">
                    {jerseyNumberNameDisplay(player)}
                  </TableCell>
                  <TableCell className="stat-cell">{stats.completions}</TableCell>
                  <TableCell className="stat-cell">{stats.attempts}</TableCell>
                  
                  <TableCell className="stat-cell">{stats.yards}</TableCell>
                  <TableCell className="stat-cell">{stats.touchdowns}</TableCell>
                  <TableCell className="stat-cell">{stats.interceptions}</TableCell>
                  <TableCell className="stat-cell">
                    {stats.completion_percentage.toFixed(1)}%
                  </TableCell>
                  <TableCell className="stat-cell">{stats.passer_rating.toFixed(1)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
